import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/a250/a250-logo.png")